import { useMutation } from 'urql';
import { UnsubscribeFromNewsletterDocument } from '@packages/gql/generated/shopping/UnsubscribeFromNewsletterDocument';

/* GraphQL */ `
  mutation UnsubscribeFromNewsletter($emailAddress: String!, $unsubscribeValue: String) {
    changeNewsletterRecipient(
      unsubscribeRequest: { emailAddress: $emailAddress, unsubscribeValue: $unsubscribeValue }
    ) {
      ... on ErrorResponse {
        errors
      }
      ... on SubscribeResponseData {
        success
      }
    }
  }
`;

export const useUnsubscribeNewsletterGql = () => {
  const [, executeMutation] = useMutation(UnsubscribeFromNewsletterDocument);
  return executeMutation;
};
